import type { API_RESPONSE } from '@corefront/eva-fe-sdk';
import type { AnyAction } from 'redux';
import { createSelector } from 'reselect';
import { pathOr } from 'ramda';
import {
  SET_BIG_WINS_DATA,
  SET_BIG_WINS_COUNTRIES,
  SET_BIG_WINS_CURRENCY,
  SET_BIG_WINS_HISTORY_LOADED,
} from '../../../../constants/centrifugo';
import { PROJECTS } from '../../../../../constants/centrifugo';
import type { RootState } from '../../../../store';

interface BigWinsState {
  data: API_RESPONSE.BigWins[200];
  isHistoryLoaded: boolean;
  currency: {};
  countries: string[];
}

const initialState: BigWinsState = {
  data: [],
  isHistoryLoaded: false,
  currency: {},
  countries: [],
};

export const bigWinsReducer = (
  state = initialState,
  action: AnyAction
): BigWinsState => {
  switch (action.type) {
    case SET_BIG_WINS_DATA: {
      return {
        ...state,
        data: [...action.payload, ...state.data],
      };
    }

    case SET_BIG_WINS_HISTORY_LOADED: {
      return {
        ...state,
        isHistoryLoaded: true,
      };
    }

    case SET_BIG_WINS_CURRENCY: {
      return {
        ...state,
        currency: action.payload,
      };
    }

    case SET_BIG_WINS_COUNTRIES: {
      return {
        ...state,
        countries: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
export default bigWinsReducer;

const bigWinObjSelector = (state: RootState) =>
  pathOr(initialState, ['domain', 'centrifugo', PROJECTS.BIG_WINS], state);

export const bigWinsSelector = createSelector(bigWinObjSelector, (state) =>
  pathOr(initialState.data, ['data'], state)
);

export const isBigWinsHistoryLoadedSelector = createSelector(
  bigWinObjSelector,
  (state) => pathOr(initialState.isHistoryLoaded, ['isHistoryLoaded'], state)
);

export const bigWinsCurrencySelector = createSelector(
  bigWinObjSelector,
  (state) => pathOr(initialState.currency, ['currency'], state)
);

export const bigWinsCountriesSelector = createSelector(
  bigWinObjSelector,
  (state) => pathOr(initialState.countries, ['countries'], state)
);

export const bigWinsCurrencyRateSelector = createSelector(
  bigWinsCurrencySelector,
  (currency) => pathOr(null, ['rate'], currency)
);

export const bigWinsCurrencyNameSelector = createSelector(
  bigWinsCurrencySelector,
  (currency) => pathOr(null, ['code'], currency)
);
